var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendarCheck = function SvgCalendarCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C80B",
    d: "M4.571 0c.475 0 .858.376.858.844V2.25h5.142V.844c0-.468.383-.844.858-.844s.857.376.857.844V2.25h1.428C14.975 2.25 16 3.259 16 4.5v11.25c0 1.241-1.025 2.25-2.286 2.25H2.286C1.025 18 0 16.991 0 15.75V4.5c0-1.241 1.025-2.25 2.286-2.25h1.428V.844c0-.468.382-.844.857-.844Zm9.715 6.75H1.714v9c0 .31.257.563.572.563h11.428a.569.569 0 0 0 .572-.563v-9Zm-2.536 3.691-4 3.938a.863.863 0 0 1-1.21 0l-2.286-2.25a.831.831 0 0 1 0-1.192.867.867 0 0 1 1.21 0l1.679 1.652 3.393-3.34a.863.863 0 0 1 1.21 0 .834.834 0 0 1 0 1.192h.004Z"
  })));
};
export default SvgCalendarCheck;